const BundlesEnum = {
  PRODUCT: 'prodotto',
  BRAND: 'scheda_espositore',
};

const accordionChildren = {
  [BundlesEnum.PRODUCT]: {
    general: [
      'field_immagine_anteprima',
      'field_prodotto_nuovo',
      'field_prodotto_anteprima',
      'field_prodotto_esposto',
      'field_unboxing_2024',
      'field_classe_merceologica',
      'field_categoria',
      'field_sotto_categoria',
      'field_private_collezione',
    ],
    basic: ['title', 'field_brand', 'body', 'field_cover', 'field_didascalia'],
  },
  [BundlesEnum.BRAND]: {
    general: [
      'field_logo',
      'field_email_di_contatto',
      'field_email_di_contatto_estero',
      'field_link_facebook',
      'field_link_instagram',
      'field_link_linkedin',
      'field_link_pinterest',
      'field_link_twitter',
    ],
    basic: ['title', 'field_cover', 'body'],
  },
};

const AutocompleteEnum = {
  productClasses: 'classi_merceologiche',
  productCategories: 'espositori_stanza',
  productSubCategories: 'sotto_categoria',
};

const FieldTypeEnum = {
  TEXT_WITH_SUMMARY: 'text_with_summary',
  ENTITY_REFERENCE: 'entity_reference',
  ENTITY_REFERENCE_REVISIONS: 'entity_reference_revisions',
  IMAGE: 'image',
  FILE: 'file',
  TEXT_LONG: 'text_long',
  STRING_LONG: 'string_long',
  STRING: 'string',
  LINK: 'link',
  EMAIL: 'email',
  YEAR_ONLY: 'yearonly',
  INTEGER: 'integer',
  BOOLEAN: 'boolean',
};

const FormReactFCEnum = {
  RADIO_GROUP: 'RadioGroup',
  IMAGE_DROPZONE: 'DropZone',
  AUTOCOMPLETE: 'Autocomplete',
  ACCORDION: 'Accordion',
  RICH_TEXT: 'RichText',
  TEXTFIELD: 'Textfield',
  TEXTAREA: 'TextArea',
};

const ParagraphEnum = {
  DESIGNER: 'designer',
  FREE_IMAGE: 'free_image',
  FREE_IMAGE_FULL_SCREEN: 'immagine_libera_full_screen',
  SD_BRAND_MULTITEXT: 'sd_brand_multitext',
  SDM_QUOTED_TEXT: 'sdm_quoted_text',
  SLIDER_DETAIL: 'slider_detail',
  TECHNICAL_SHEET: 'technical_sheet',
  TITLE_SECTION: 'section_title',
  VIMEO_VIDEO: 'vimeo_video',
  YOUTUBE_VIDEO: 'youtube_video',
  VIRTUAL_SHOWROOM: 'virtual_showroom',
};

const ParagraphTypeEnum = {
  DESIGNER: 'paragraph--designer',
  FREE_IMAGE: 'paragraph--free_image',
  FREE_IMAGE_FULL_SCREEN: 'paragraph--immagine_libera_full_screen',
  SD_BRAND_MULTITEXT: 'paragraph--sd_brand_multitext',
  SDM_QUOTED_TEXT: 'paragraph--sdm_quoted_text',
  SLIDER_DETAIL: 'paragraph--slider_detail',
  TECHNICAL_SHEET: 'paragraph--technical_sheet',
  TITLE_SECTION: 'paragraph--section_title',
  VIMEO_VIDEO: 'paragraph--vimeo_video',
  YOUTUBE_VIDEO: 'paragraph--youtube_video',
  VIRTUAL_SHOWROOM: 'paragraph--virtual_showroom',
};

const FormSubmitEnum = {
  PREVIEW: 'preview',
  DRAFT: 'draft',
  PUBLISH: 'publish',
  BACK: 'back',
  TRANSLATE: 'translate',
};

const AccordionNameEnum = {
  GENERAL: 'general',
  BASIC: 'basic',
  ADDITIONAL: 'additional',
};

const PathInfoImages = (lang) => ({
  [AccordionNameEnum.GENERAL]: {
    field_immagine_anteprima: `/themes/custom/sdm/images/drawer/field_immagine_anteprima_${lang}.jpg`,
    field_logo: `/themes/custom/sdm/images/drawer/field_logo_${lang}.jpg`,
  },
  [AccordionNameEnum.ADDITIONAL]: {
    [ParagraphEnum.DESIGNER]: `/themes/custom/sdm/images/drawer/designer_${lang}.jpg`,
    [ParagraphEnum.FREE_IMAGE]: `/themes/custom/sdm/images/drawer/free_image_${lang}.jpg`,
    [ParagraphEnum.FREE_IMAGE_FULL_SCREEN]: `/themes/custom/sdm/images/drawer/immagine_libera_full_screen_${lang}.jpg`,
    [ParagraphEnum.SD_BRAND_MULTITEXT]: `/themes/custom/sdm/images/drawer/sd_brand_multitext_${lang}.jpg`,
    [ParagraphEnum.SDM_QUOTED_TEXT]: `/themes/custom/sdm/images/drawer/sdm_quoted_text_${lang}.jpg`,
    [ParagraphEnum.TITLE_SECTION]: `/themes/custom/sdm/images/drawer/sd_brand_multitext_${lang}.jpg`,
    [ParagraphEnum.SLIDER_DETAIL]: `/themes/custom/sdm/images/drawer/slider_detail_${lang}.jpg`,
    [ParagraphEnum.TECHNICAL_SHEET]: `/themes/custom/sdm/images/drawer/technical_sheet_${lang}.jpg`,
    [ParagraphEnum.VIMEO_VIDEO]: `/themes/custom/sdm/images/drawer/vimeo_video_${lang}.jpg`,
    [ParagraphEnum.YOUTUBE_VIDEO]: `/themes/custom/sdm/images/drawer/youtube_video_${lang}.jpg`,
    [ParagraphEnum.VIRTUAL_SHOWROOM]: `/themes/custom/sdm/images/drawer/virtual_showroom_${lang}.jpg`,
  },
});

const BundleStates = {
  DRAFT: 'draft',
  REVIEW: 'review',
  REVISED: 'revised',
  APPROVED: 'approved',
  PUBLISHED: 'published',
};

const BundleJsonApiStates = {
  [BundlesEnum.PRODUCT]: {
    [BundleStates.DRAFT]: 'draft',
    [BundleStates.REVIEW]: 'review',
    [BundleStates.REVISED]: 'revised',
    [BundleStates.APPROVED]: 'anteprima_approvata',
    [BundleStates.PUBLISHED]: 'published',
  },
  [BundlesEnum.BRAND]: {
    [BundleStates.DRAFT]: 'draft',
    [BundleStates.REVIEW]: 'vcd88fegwhu_',
    [BundleStates.REVISED]: 'in_attesa_di_revisione',
    [BundleStates.APPROVED]: 'anteprima_approvata',
    [BundleStates.PUBLISHED]: 'published',
  },
};

export {
  accordionChildren,
  BundlesEnum,
  FieldTypeEnum,
  FormReactFCEnum,
  ParagraphEnum,
  ParagraphTypeEnum,
  FormSubmitEnum,
  AutocompleteEnum,
  AccordionNameEnum,
  PathInfoImages,
  BundleJsonApiStates,
  BundleStates,
};
